<template>
    <div class='box'>
        <carousel :list="webDate.cooperationBanner" height="400px" v-if="webDate"></carousel>
        <div class="cooper">
            <pageTitle title="品牌授权" subtitle="Brand authorization"></pageTitle>

            <div class="table">

                <el-form :inline="true" label-width="100px">
                    <el-form-item label="授权编号:">
                        <el-input v-model="queryParams.no" clearable class="searchsize" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="客户名称:">
                        <el-input v-model="queryParams.name" clearable class="searchsize" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="授权区域:">
                        <el-input v-model="queryParams.area" clearable class="searchsize" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="授权等级:">
                        <el-select v-model="queryParams.level" clearable placeholder="请选择">
                            <el-option label="区域代理商" value="区域代理商"></el-option>
                            <el-option label="授权使用商" value="授权使用商"></el-option>
                            <el-option label="特许生产工厂" value="特许生产工厂"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="changeQuery()">查询</el-button>
                    </el-form-item>
                </el-form>

                <el-table :data="tableData" style="width: 100%;height: 770px;" stripe :row-class-name="tableRowClassName" v-loading="tabLoading">
                    <el-table-column prop="no" label="授权编号" width="280" align="center" />
                    <el-table-column prop="name" label="客户名称" width="280" align="center" />
                    <el-table-column prop="area" label="授权区域" align="center" />
                    <el-table-column prop="expireDate" label="授权有限期" align="center" />
                    <el-table-column prop="level" label="授权等级" align="center" />
                    <!-- <el-table-column prop="factory" label="是否特殊工厂" align="center" /> -->
                </el-table>

                <div class="pagination_box">
                    <pagination :total="total" v-model:pageNum='queryParams.pageNum' v-model:pageSize='queryParams.pageSize' @currentChange='getList'></pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import carousel from '../../components/carousel.vue'
import pageTitle from '../../components/pageTitle.vue'
import pagination from '../../components/pagination.vue'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { getTablePage } from '@/api/Cooperation/index.js'
const store = useStore()
const webDate = computed(() => store.state.webDate);

const queryParams = ref({
    pageNumber: 1,
    pageSize: 10,
    no: null,
    name: null,
    area: null,
    level: null,
})
const total = ref(0);
const tableData = ref([]);
const tabLoading = ref(false);
const getList = () => {
    tabLoading.value = true;
    getTablePage(queryParams.value).then(res => {
        if (res.code == 0) {
            tableData.value = res.data;
            total.value = res.total;
        }
        tabLoading.value = false;
    }).catch(err => {
        tabLoading.value = false;
    })
}
getList();


const changeQuery = () => {
    queryParams.value.pageNum = 1;
    getList();
}

const tableRowClassName = ({ row, rowIndex, }) => {
    if (rowIndex === 1) {
        return 'warning-row'
    } else if (rowIndex === 3) {
        return 'success-row'
    }
    return ''
}
</script>

<style scoped lang='scss'>
.cooper {
    padding: 70px 160px;

    .table {
        margin-top: 48px;

        &::v-deep .el-table__header th {
            background-color: #024d74;
            color: #ffffff !important;
            height: 70px;
        }

        &::v-deep .el-table__body tr {
            height: 70px;
        }
    }
}

.pagination_box {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 50px 0;
}
</style>